import Layout from 'components/Layout';
import useLiterals from 'utils/hooks/useLiterals';
import { ROUTE_PATH } from 'routes';
import Button from 'components/UI/Button';
import Modal from 'components/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { onLogout } from 'modules/session/actions';

const InactiveSession = () => {
  const literals = useLiterals('inactiveSession');
  const { authenticated } = useSelector((state) => state.session);
  const dispatch = useDispatch();

  useEffect(() => {
    if (authenticated) {
      dispatch(onLogout());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout>
      <Modal showCloseButton={false} closeOnBackgroundClick={false}>
        <div className='text-center'>
          <h1 className='mb-6'>{literals.title}</h1>
          <p className='mb-12'>{literals.description}</p>
        </div>
        <Button to={ROUTE_PATH.LOGIN} text={literals.goToLogin} />
      </Modal>
    </Layout>
  );
};

export default InactiveSession;
